/** Assemble des segments non vides avec un séparateur — un champ absent
 *  (secteur non trouvé, ville inconnue...) ne laisse plus de "· ·" ou de
 *  parenthèses vides dans l'en-tête d'une fiche ou d'une ligne de résultat. */
export function joindre(...segments: (string | null | undefined)[]): string {
  return segments.filter((s): s is string => Boolean(s)).join(" · ");
}

/** "Ville (département)", ou l'un des deux seul si l'autre manque. */
export function villeDepartement(ville?: string | null, departement?: string | null): string | null {
  if (ville && departement) return `${ville} (${departement})`;
  if (ville) return ville;
  if (departement) return `(${departement})`;
  return null;
}
